<app-section
  titleSection="Les moins"
  [isActivated]="drawbacks.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-les-moins-read-mode [drawbacks]="drawbacks"> </app-les-moins-read-mode>
  </div>

  <div edit-mode>
    <app-les-moins-edit-mode
      [drawbacks]="drawbacks"
      (drawbacksChanged)="onDrawbacksChanged($event)"
    >
    </app-les-moins-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
